import React from 'react';
import { Alert, Collapse } from '@mui/material';
import { CloudOff as CloudOffIcon } from '@mui/icons-material';
import { useNetwork } from '../../context/NetworkContext';

const savedLabel = (savedAt) => {
  const saved = new Date(savedAt);
  const sameDay = saved.toDateString() === new Date().toDateString();
  const time = saved.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  return sameDay ? `today at ${time}` : `${saved.toLocaleDateString([], { day: 'numeric', month: 'short' })} at ${time}`;
};

/** Thin notice under the navbar while the API can't be reached. */
const OfflineBanner = () => {
  const { offline, savedAt } = useNetwork();
  return (
    <Collapse in={offline} unmountOnExit>
      <Alert
        severity="warning"
        icon={<CloudOffIcon fontSize="inherit" />}
        sx={{ borderRadius: 0, py: 0.25, justifyContent: 'center', '& .MuiAlert-message': { textAlign: 'center' } }}
        role="status"
      >
        <strong>You're offline.</strong>{' '}
        {savedAt ? `Data saved ${savedLabel(savedAt)}. ` : ''}
        Changes are saved on this device and will sync when you have signal.
      </Alert>
    </Collapse>
  );
};

export default OfflineBanner;
